import Delta from 'quill-delta';
import getOperationOffset from '../utils/getOperationOffset';
import getNodeLength from '../utils/getNodeLength';
export default function removeNode(op, editor) {
  return new Delta().retain(getOperationOffset(op, editor))["delete"](getNodeLength(op.node));
}